import { LoadingOutlined } from "@ant-design/icons";
import { useModal } from "@ebay/nice-modal-react";
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Radio,
  Row,
  Spin,
} from "antd";
import BaseModal from "components/foundation/modal/BaseModal";
import simDetailImg from "global/images/dktt/Sim_detail.png";
import React, { useEffect } from "react";
import Format from "utils/format/Format";
import { DkttbConstants } from "../../constants/DkttbConstants";
import usePickSimModel from "../../viewmodel/model/pickSim/PickSimModel";
import ResutlModal from "../modal/ResutlModal";
import { useAuth } from "global/context/AuthenticationContext";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 42,
      color: "var(--mk-p-color)",
    }}
    spin
  />
);

const PickSimPage: React.FC = () => {
  const userModal = useModal(BaseModal);
  const [form] = Form.useForm();
  const { fee } = useAuth();
  const { simOrEsim } = DkttbConstants.render();

  const simTypeValue = Form.useWatch("sim_type", form);

  const {
    id,
    loading,
    resultObject,
    detail,
    plan,
    planPrice,
    totalAmount,
    simType,
    setSimType,
    setTotalAmount,
    setPlanPrice,
  } = usePickSimModel();

  const planIdValue = Form.useWatch("plan_id", form);

  const onClose = async () => {
    userModal.hide();
  };

  const resutlModel = async (values: any) => {
    if (values) {
      const selectedPlan = plan.find((plan: any) => plan.id === planIdValue);
      let info = {
        id,
        ...detail,
        ...values,
        selectedPlan,
      };
      userModal
        .show({
          children: <ResutlModal info={info} onClose={onClose} />,
        })
        .then((values: any) => {})
        .catch((e) => {});
    }
  };

  useEffect(() => {
    if (detail) {
      const formData: { [key: string]: any } = {};

      if (detail.planId?.trim()) {
        formData.plan_id = detail.planId;
      }

      if (detail.serial?.trim()) {
        formData.serial = detail.serial;
      }
      form.setFieldsValue(formData);
    }
  }, [detail, form]);

  useEffect(() => {
    if (planIdValue) {
      const selectedPlan = plan.find((p: any) => p.id === planIdValue);
      if (selectedPlan) {
        const currentPlanPrice = selectedPlan.price;

        const esimFee = simTypeValue === "ESIM" ? fee?.esimActivation || 0 : 0;

        const newTotalAmount =
          (detail?.baseFee || 0) +
          (detail?.activationFee || 0) +
          currentPlanPrice +
          esimFee;

        setPlanPrice(currentPlanPrice);
        setTotalAmount(newTotalAmount);
      }
    } else if (detail) {
      const esimFee = simTypeValue === "ESIM" ? fee?.esimActivation || 0 : 0;
      setTotalAmount(detail.totalAmount + esimFee);
    }
  }, [planIdValue, simTypeValue, plan, detail, fee]);

  useEffect(() => {
    if (!!resultObject?.message) {
      switch (resultObject?.type) {
        case "success":
          message.success(resultObject?.message);
          break;
        case "error":
          message.error(resultObject?.message);
          break;
        default:
          break;
      }
    }
  }, [resultObject]);

  return (
    <div className="lg:px-[40px] lg:py-[20px] p-2 keep-number-page">
      <Spin
        spinning={loading}
        indicator={antIcon}
        tip={<span style={{ color: "var(--mk-p-color)" }}>Đang tải...</span>}
        size="large"
      >
        <Form
          form={form}
          layout="horizontal"
          onFinish={resutlModel}
          initialValues={{ sim_type: "SIM_VAT_LY" }}
        >
          <div className="mx-auto w-full bg-white rounded-2xl lg:flex lg:flex-row lg:justify-between lg:items-center px-7 py-5 text-center lg:text-left">
            <div className="flex flex-row lg:justify-start justify-center items-center gap-x-3">
              <Image
                src={simDetailImg}
                alt="choose-package-banner"
                width={30}
                height={30}
                className="object-cover"
              />

              <p className="lg:text-[31px] text-[24px] lg:font-[800] font-[600] text-black">
                {detail?.phoneNumber}
              </p>
            </div>

            <div className="lg:flex lg:justify-end lg:items-center gap-2">
              <p className="lg:text-[26px] text-[22px] font-[700] text-black">
                {Format.DPrice(detail?.simFee)}
              </p>
              <p className="text-[12px] text-black font-normal lg:w-[fit-content] ">
                {"(Chưa bao gồm, giá sim và gói cước)"}
              </p>
            </div>
          </div>
          <br />

          <div className="mx-auto w-full bg-white rounded-2xl lg:px-7 lg:py-5 p-3">
            <Form.Item
              name="sim_type"
              label={
                <p className="text-[16px] font-[600] text-black mb-2">
                  {"1. CHỌN LOẠI SIM"}
                </p>
              }
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Hãy chọn loại sim!",
                },
              ]}
            >
              <Row gutter={[5, 0]} style={{ width: "100%" }}>
                {simOrEsim?.map((item, index) => (
                  <Col
                    key={`sim-type-${index}`}
                    span={24}
                    lg={index === 0 ? 9 : 15}
                  >
                    <Radio
                      value={item.key}
                      style={{ fontWeight: 600, fontSize: 14 }}
                      checked={simType === item.key}
                      onChange={(e) => setSimType(e.target.value)}
                    >
                      {item.label}
                    </Radio>

                    <p className="text-[12px] text-black ml-6">
                      {item.description}
                    </p>
                  </Col>
                ))}
              </Row>
            </Form.Item>

            <Form.Item
              name="plan_id"
              label={
                <p className="text-[16px] font-[600] text-black mb-2">
                  {"2. CHỌN GÓI CƯỚC"}
                </p>
              }
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Hãy chọn gói cước!",
                },
              ]}
            >
              <div
                className={`w-full min-h-[200px] max-h-[450px] overflow-y-auto mb-3 ${
                  detail?.planId ? "pointer-events-none opacity-60" : ""
                }`}
              >
                <p className="text-[12px] text-black ml-6 mb-2">
                  {"Chọn 1 trong các gói cước"}
                </p>

                <Row gutter={[12, 12]} className="w-full lg:px-5 lg:py-2 p-1 ">
                  {plan?.map((item: any, index: number) => {
                    const isSelected = planIdValue === item.id;

                    return (
                      <Col
                        key={`plan-${index}`}
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={4}
                        onClick={() =>
                          !detail?.planId &&
                          form.setFieldsValue({ plan_id: item?.id })
                        }
                      >
                        <div
                          className={`border rounded-xl cursor-pointer shadow-lg px-3 py-3 transition ${
                            isSelected
                              ? "shadow-xl scale-[1.02]"
                              : "hover:border-[var(--mk-p-color)]"
                          }`}
                          style={{
                            borderColor: isSelected
                              ? "var(--mk-p-color)"
                              : "#d1d5db",
                            backgroundColor: isSelected
                              ? "rgba(0,0,0,0.02)"
                              : "white",
                          }}
                        >
                          <div className="bg-gray-100 w-full h-[120px] rounded-lg px-2 py-1">
                            <div className="font-[500] uppercase text-[18px] text-black border-b border-gray-400">
                              {item.name}
                            </div>

                            {item.description ? (
                              item.description.includes("\n") ? (
                                <ul className="custom-marker text-[12px] mt-1">
                                  {item.description
                                    .split("\n")
                                    .map((desc: string, index: number) => (
                                      <li key={index} className="leading-snug">
                                        {desc.replace(/^[-\s\t]+/, "").trim()}
                                      </li>
                                    ))}
                                </ul>
                              ) : (
                                <p className="text-[12px] mt-1">
                                  {item.description
                                    .replace(/^[-\s\t]+/, "")
                                    .trim()}
                                </p>
                              )
                            ) : null}
                          </div>
                          <div className="mt-2 px-1">
                            <div className="font-[700] text-[15px]">
                              {Format.DPrice(item.price)}
                            </div>

                            {item?.discountValue ? (
                              <div className="text-[10px] text-[#FF0000]">
                                {"Chiết khấu "}
                                {item?.discountType === 1 ? (
                                  <>{Format.DPrice(item?.discountValue)}</>
                                ) : (
                                  <>{Format.Percent(item?.discountValue)}</>
                                )}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </Form.Item>

            {simTypeValue !== "ESIM" && (
              <>
                <p className="text-[16px] font-[600] text-black mb-2">
                  {"3. NHẬP SERIAL "}
                </p>

                <Form.Item
                  name="serial"
                  label="Nhập serial phôi sim trắng"
                  labelCol={{ span: 5 }}
                  rules={[
                    {
                      required: simTypeValue === "SIM_VAT_LY",
                      message: "Hãy nhập serial phôi sim trắng!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Serial phôi sim trắng"
                    size="large"
                    disabled={!!detail?.serial}
                  />
                </Form.Item>
              </>
            )}
          </div>

          <Row gutter={[0, 0]} style={{ width: "100%" }}>
            <Col xs={24} sm={24} md={20} lg={20} xl={20}>
              <div className="lg:px-7 lg:py-5 p-3">
                <div className="flex flex-col lg:flex-row items-center justify-center gap-3">
                  <div className="flex items-center justify-center gap-3 w-full">
                    <div className="flex flex-col items-center">
                      <p className="lg:text-[11px] text-[9px]">
                        Phí giữ số (10% giá trị số)
                      </p>
                      <p className="lg:text-[20px] text-[15px] font-[700]">
                        {Format.DPrice(detail?.baseFee)}
                      </p>
                    </div>

                    <span className="lg:text-[20px] text-[15px] font-[700]">
                      +
                    </span>
                  </div>

                  {simTypeValue === "ESIM" && (
                    <div className="flex items-center gap-2">
                      <div className="flex flex-col items-center">
                        <p className="lg:text-[11px] text-[9px]">Phí ESIM</p>
                        <p className="lg:text-[20px] text-[15px] font-[700]">
                          {Format.DPrice(fee.esimActivation)}
                        </p>
                      </div>

                      <span className="lg:text-[20px] text-[15px] font-[700]">
                        +
                      </span>
                    </div>
                  )}

                  <div className="flex items-center justify-center gap-3 w-full">
                    <div className="flex flex-col items-center">
                      <p className="lg:text-[11px] text-[9px]">Gói cước</p>
                      <p className="lg:text-[20px] text-[15px] font-[700]">
                        {Format.DPrice(planPrice)}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center justify-center gap-3 w-full">
                    <span className="lg:text-[20px] text-[15px] font-[700]">
                      +
                    </span>

                    <div className="flex flex-col items-center">
                      <p className="lg:text-[11px] text-[9px]">Phí hòa mạng</p>
                      <p className="lg:text-[20px] text-[15px] font-[700]">
                        {Format.DPrice(detail?.activationFee)}
                      </p>
                    </div>

                    <span className="lg:text-[20px] text-[15px] font-[700]">
                      =
                    </span>

                    <div className="flex flex-col items-center">
                      <p className="lg:text-[11px] text-[9px]">Tổng tiền</p>
                      <p className="lg:text-[20px] text-[15px] font-[700] text-[#FF0202]">
                        {Format.DPrice(totalAmount)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={4}
              lg={4}
              xl={4}
              className="p-3 lg:px-7 lg:py-8"
            >
              <Button type="primary" htmlType="submit">
                {"Thanh toán"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};

export default PickSimPage;
